<i class="icon fa"
   [ngClass]="faIcon"
   [class.fa-fw]="iconWidth === 'fixed'"></i>
